/* @flow */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'preact-redux';
import { type PreactAppStore } from '../preact-app/types';
import getStore from '../preact-app/get-store';

const renderTopBar = () => {
    const header = document.getElementById('m_header_topbar');

    if (!header) {
        return;
    }

    const store: PreactAppStore = getStore();
    import('./TopBarConnected')
        .then(module => module.default)
        .then((TopBarConnected) => {
            render(
                <Provider store={store}>
                    <TopBarConnected />
                </Provider>,
                header,
            );
        });
};

export default renderTopBar;
